import { Component } from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import { addLocalRecentHistoryItem } from 'dibs-recent-history/exports/addLocalRecentHistoryItem';

export class PdpSharedRecentHistoryTrackerDeprecatedComponent extends Component {
    componentDidMount() {
        const { item } = this.props;
        addLocalRecentHistoryItem(item);
    }

    render() {
        return null;
    }
}

PdpSharedRecentHistoryTrackerDeprecatedComponent.propTypes = {
    item: PropTypes.object,
};

export const PdpSharedRecentHistoryTrackerDeprecated = createFragmentContainer(
    PdpSharedRecentHistoryTrackerDeprecatedComponent,
    {
        item: graphql`
            fragment PdpSharedRecentHistoryTrackerDeprecated_item on Item {
                ...addLocalRecentHistory_item @relay(mask: false)
            }
        `,
    }
);
